import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Little Maker a complètement transformé notre façon d'enseigner la technologie. Les élèves adorent et les résultats sont impressionnants.",
      author: "Marie Dupont",
      role: "Enseignante CM1-CM2",
      school: "École Primaire Les Lilas, Lyon",
      image: "MD",
      stats: "+40% d'engagement en sciences"
    },
    {
      id: 2,
      quote: "La formation des enseignants est exceptionnelle. En quelques semaines, nous étions autonomes et passionnés par le programme.",
      author: "Thomas Martin",
      role: "Directeur d'école",
      school: "École Internationale, Paris",
      image: "TM",
      stats: "100% des enseignants formés"
    },
    {
      id: 3,
      quote: "Les kits sont parfaitement adaptés à l'âge des enfants. La progression est bien pensée et les projets très motivants.",
      author: "Sophie Leroux",
      role: "Responsable pédagogique",
      school: "Groupe scolaire Descartes, Toulouse",
      image: "SL",
      stats: "92% de satisfaction des parents"
    }
  ];

  const workshopImages = [
    {
      id: 1,
      title: "Atelier robotique CE2",
      description: "Les élèves découvrent la programmation de robots"
    },
    {
      id: 2,
      title: "Projet créatif CM1",
      description: "Création de jeux vidéo avec Scratch"
    },
    {
      id: 3,
      title: "Club techno",
      description: "Session extrascolaire très appréciée"
    }
  ];

  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-light-5">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-dark-1 mb-4 font-sans">
            Ils nous font confiance
          </h2>
          <p className="text-light-1 text-lg max-w-3xl mx-auto font-sans">
            Découvrez les retours d'enseignants et directeurs d'école qui utilisent Little Maker
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Témoignages */}
          <div>
            <h3 className="text-xl font-bold text-dark-1 mb-6 font-sans">Témoignages</h3>
            <div className="space-y-6">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="bg-white rounded-2xl p-6 shadow-sm">
                  <div className="flex items-start mb-4">
                    <div className="w-12 h-12 bg-purple-3 rounded-full flex items-center justify-center text-purple-1 font-semibold mr-4">
                      {testimonial.image}
                    </div>
                    <div>
                      <h4 className="font-bold text-dark-1 font-sans">{testimonial.author}</h4>
                      <p className="text-light-1 text-sm font-sans">{testimonial.role}</p>
                      <p className="text-light-1 text-sm font-sans">{testimonial.school}</p>
                    </div>
                  </div>
                  <p className="text-dark-1 italic mb-3 font-sans">"{testimonial.quote}"</p>
                  <div className="bg-green-1 bg-opacity-20 rounded-lg px-3 py-2 inline-block">
                    <span className="text-green-1 text-sm font-medium font-sans">✓ {testimonial.stats}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Photos d'ateliers */}
          <div>
            <h3 className="text-xl font-bold text-dark-1 mb-6 font-sans">Ateliers en images</h3>
            <div className="grid grid-cols-2 gap-4">
              {workshopImages.map((workshop) => (
                <div key={workshop.id} className="bg-dark-5 rounded-2xl aspect-square flex items-center justify-center relative group overflow-hidden">
                  <div className="text-4xl text-white opacity-70">📸</div>
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-end p-4">
                    <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <h4 className="text-white font-semibold text-sm font-sans">{workshop.title}</h4>
                      <p className="text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">{workshop.description}</p>
                    </div>
                  </div>
                </div>
              ))}
              <div className="bg-gradient-to-br from-purple-1 to-blue-1 rounded-2xl aspect-square flex flex-col items-center justify-center p-4 text-center">
                <div className="text-3xl text-white mb-2">🎬</div>
                <p className="text-white text-sm font-sans">Voir toutes nos vidéos d'ateliers</p>
              </div>
            </div>
          </div>
        </div>

        {/* Études de cas */}
        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <h3 className="text-xl font-bold text-dark-1 mb-6 font-sans text-center">Études de cas réussies</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🏫</span>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">École Primaire de Versailles</h4>
              <p className="text-light-1 text-sm font-sans">+60% d'intérêt pour les sciences en 6 mois</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">👨‍👩‍👧‍👦</span>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">Groupe Scolaire International</h4>
              <p className="text-light-1 text-sm font-sans">95% de satisfaction des parents d'élèves</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-dark-2 text-2xl">📊</span>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">Collège Innovant</h4>
              <p className="text-light-1 text-sm font-sans">Réduction de 40% du décrochage scolaire</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;